import * as tslib_1 from "tslib";
import * as React from 'react';
import commonStrings from 'owa-strings/owa-common-strings';
import mailStrings from 'owa-strings/owa-mail-strings';
import { folderForestStore } from 'owa-mail-folder-forest-store';
import { getScenarioStore, SearchBox, SearchScenarioId } from 'owa-search';
import { getStore } from '../store/store';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isFolderOrSubFolderOfArchiveRoot } from 'owa-mail-store';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import { observer } from 'mobx-react';
import { onMailSearchBoxContainerInitialized, onOwaResized } from '../actions/bootActions';
import { SearchRefiners, shouldCenterSearchBox } from 'owa-mail-search';
var MailSearchBoxContainer = /** @class */ (function (_super) {
    tslib_1.__extends(MailSearchBoxContainer, _super);
    function MailSearchBoxContainer(props, state) {
        var _this = _super.call(this, props, state) || this;
        /**
         * This callback dispatches an action to respond to OWA being resized.
         */
        _this.onOwaResize = function () {
            onOwaResized();
        };
        // Dispatch action to handle any initialization before render.
        onMailSearchBoxContainerInitialized();
        return _this;
    }
    MailSearchBoxContainer.prototype.componentDidMount = function () {
        lazySubscribeToResizeEvent.importAndExecute(this.onOwaResize);
    };
    MailSearchBoxContainer.prototype.componentWillUnmount = function () {
        lazyUnsubscribeFromResizeEvent.importAndExecute(this.onOwaResize);
    };
    MailSearchBoxContainer.prototype.render = function () {
        var _this = this;
        /**
         * For the centered search box treatment, the search box is fixed
         * width and does not grow on focus.
         */
        var isFixedWidth = shouldCenterSearchBox();
        return (React.createElement(SearchBox, { customCollapsedMaxWidth: getStore().searchBoxWidth, isUsing3S: is3SFeatureEnabled('sea-qf'), ref: function (ref) { return (_this.searchBox = ref); }, renderRefiners: function () { return React.createElement(SearchRefiners, null); }, searchPlaceHolderText: this.getSearchPlaceholderText(), isDisabled: this.props.isDisabled, scenarioId: SearchScenarioId.Mail, supportsCommandMode: true, isFixedWidth: isFixedWidth }));
    };
    /**
     * Publically exposed function that allows parent to set focus inside of the
     * search input.
     */
    MailSearchBoxContainer.prototype.setFocus = function () {
        this.searchBox.focusSearchInput();
    };
    /**
     * If the slash commands flight is disabled, set the search text to be
     * "Search". Otherwise, if this flight is enabled, change the search text
     * to "Search or type a command" if the search box is closed or "Search or
     * type / for a list of commands​" if the search box is expanded.
     */
    MailSearchBoxContainer.prototype.getPrimaryMailboxSearchPlaceholderText = function () {
        if (isControlFeatureEnabled('sea-slashCommands')) {
            var searchStore = getScenarioStore(SearchScenarioId.Mail);
            var isSearchBoxExpanded = !!searchStore.searchSessionGuid;
            if (!isSearchBoxExpanded) {
                return 'Search or type a command';
            }
            else {
                return 'Search or type / for a list of commands';
            }
        }
        else {
            return mailStrings.SearchPlaceholder;
        }
    };
    /**
     * Returns the placeholder text for the search box.
     */
    MailSearchBoxContainer.prototype.getSearchPlaceholderText = function () {
        /**
         * Currently, there's only 1 scenario (user viewing a private group that
         * they are not a member of) where the search box is disabled, so checking
         * isDisabled prop is sufficient.
         */
        if (this.props.isDisabled) {
            return commonStrings.SearchDisabledPrivateGroup;
        }
        /**
         * If search box is not disabled, return the appropriate string depending
         * on if the user is in their primary or archive mailbox.
         */
        if (folderForestStore.selectedNode &&
            isFolderOrSubFolderOfArchiveRoot(folderForestStore.selectedNode.id)) {
            return mailStrings.archiveMailboxFoldersSearchPlaceholder;
        }
        else {
            return this.getPrimaryMailboxSearchPlaceholderText();
        }
    };
    MailSearchBoxContainer = tslib_1.__decorate([
        observer
    ], MailSearchBoxContainer);
    return MailSearchBoxContainer;
}(React.Component));
export default MailSearchBoxContainer;
//# sourceMappingURL=MailSearchBoxContainer.js.map